import { channels, type Channel } from "@/mocks/categories";

export function getChannel(key: string): Channel | undefined {
  return channels.find((c) => c.key === key);
}

export function channelFill(key: string): string {
  const c = getChannel(key);
  return c?.color === "accent" ? "bg-accent-500" : "bg-primary-500";
}

export function channelSoftText(key: string): string {
  const c = getChannel(key);
  return c?.color === "accent" ? "bg-accent-100 text-accent-900" : "bg-primary-100 text-primary-800";
}

export function channelDot(key: string): string {
  const c = getChannel(key);
  return c?.color === "accent" ? "bg-accent-500" : "bg-primary-500";
}

export function channelIcon(key: string): string {
  return getChannel(key)?.icon ?? "ri-flashlight-line";
}